import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import About from './views/about'
import Order from './views/order'
import Menu from './views/menu'
import Contact from './views/contact'
import FAQ from './views/faq'
import Home from './views/home'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={About} exact path="/about" />
        <Route component={Order} exact path="/order" />
        <Route component={Menu} exact path="/menu" />
        <Route component={Contact} exact path="/contact" />
        <Route component={FAQ} exact path="/faq" />
        <Route component={Home} exact path="/" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
